// extracted by mini-css-extract-plugin
export var container = "Alert-module--container--e97ff";
export var icon = "Alert-module--icon--ecd8b";
export var themeDanger = "Alert-module--themeDanger--8f4a0";
export var themeInfo = "Alert-module--themeInfo--653ad";
export var themeSuccess = "Alert-module--themeSuccess--3b5df";
export var themeWarning = "Alert-module--themeWarning--05708";